import { Router } from '@angular/router';
import { OrcamentoService } from './../../../../shared/services/orcamento.service';
import { EntrySelect } from './../../../../shared/models/EntrySelect.model';
import { Subject } from 'rxjs';
import { ProdutoServico } from './../../shared/model/produto-servico.model';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Veiculo } from '../../shared/model/veiculo.model';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MessageService } from '../../../../shared/message.service';
import { RestService } from '../../../../shared/services/rest.service'
import { SessionService } from '../../../../shared/services/session.service';
import { DICIONARIO_LAUDO_CONTRAN, ItemAvaliacao } from './laudo-contran.constants';
import { LaudopmmgPrintComponent } from '../laudopmmg-print/laudopmmg-print.component';

@Component({
  selector: 'app-laudopmmg',
  templateUrl: './laudopmmg.component.html',
  styleUrls: ['./laudopmmg.component.css']
})
export class LaudopmmgComponent implements OnInit {
  public onClose: Subject<boolean>;
  resourceForm: FormGroup;
  protocolo:string="";
  tiposVeiculo = [
    { value: '', label: '' },
    { value: 'Automóvel', label: 'Automóvel' },
    { value: 'Motocicleta', label: 'Motocicleta' },
    { value: 'Caminhão', label: 'Caminhão e Cavalo Mecânico' },
    { value: 'Ônibus', label: 'Ônibus e Micro-ônibus' }
  ];
  classificacaoDano: string = 'Pequena Monta';

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private info: MessageService,
    private rest: OrcamentoService,
    private serv: RestService,
    private session: SessionService,
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef 
  ) {
    this.onClose = new Subject();
  
  }

  close(): void {
    this.cdr.detectChanges();
    this.bsModalRef.hide();
  }

  ngOnInit(): void {
     this.buildResourceForm();
     this.rest.getLaudoPMMG(this.protocolo).subscribe(
        (data:any) => {
          var response = JSON.parse(JSON.stringify(data));
          if (response.status == 'success' && response.data?.[0]) {
            let laudo = response.data?.[0];
            this.sendDataForm(laudo);       
          }else{
            this.carregarPerguntas();
          }
        });  
  }

  buildResourceForm() {
    this.resourceForm = this.formBuilder.group({
      id: [''],
      tipoVeiculo: [null, Validators.required],
      itens: this.formBuilder.array([]), // O FormArray onde as perguntas ficarão
      nomeAgente: [null, Validators.required],
      numeroBat: [null],
      registroMatricula: [null, Validators.required],
      numeroBO: [null, Validators.required],
      observacao: [null]
    });
  }

  /**
   * Método principal para carregar ou trocar as perguntas dinamicamente
   */
  carregarPerguntas() {
    const tipo = this.resourceForm.get('tipoVeiculo')?.value;
    // Resolve a lista de perguntas do dicionário (Tratando Cavalo Mecânico como Caminhão)
    const perguntasBase = tipo === 'Cavalo Mecânico'
      ? DICIONARIO_LAUDO_CONTRAN['Caminhão']
      : DICIONARIO_LAUDO_CONTRAN[tipo];

    const itensArray = this.resourceForm.get('itens') as FormArray;

    // Limpa o array para não acumular se mudar o tipo de veículo
    itensArray.clear();

    if(!tipo) {
      itensArray.clear();
    }else{
      // Popula o FormArray com novos FormGroups
      perguntasBase.forEach(p => {
        itensArray.push(this.formBuilder.group({
          item: [p.item],
          descricao: [p.descricao],
          valor: [p.valor || null], // M ou G
          dano: ['NA', Validators.required] 
        }));
      });
    }
     
    // Reset da classificação ao trocar de tipo
    this.calcularClassificacao();
  }

  /**
   * Getter para iterar no HTML: *ngFor="let control of itensControls; let i = index"
   */
  get itensControls() {
    return (this.resourceForm.get('itens') as FormArray).controls;
  }

  checkIfEditableTipo(){
    if (this.resourceForm.get('id')?.value) {
    this.resourceForm.get('tipoVeiculo')?.disable();
    } else {
      this.resourceForm.get('tipoVeiculo')?.enable();
    }
  }
  /**
   * Lógica de cálculo conforme Resolução CONTRAN 810/2020
   * Deve ser chamada no (change) dos radio buttons no HTML
   */
  calcularClassificacao() {
  this.checkIfEditableTipo();
  // Resgata o array de itens do formulário reativo
  const itens = (this.resourceForm.get('itens') as FormArray).value || [];
  const tipo = this.resourceForm.get('tipoVeiculo')?.value;

  // Realiza as contagens baseadas nas propriedades do seu FormArray
  const totalSim = itens.filter((i: any) => i.dano === 'SIM').length;
  const totalNa = itens.filter((i: any) => i.dano === 'NA' || i.dano === 'N/A').length;
  
  // Total Geral exigido para a pontuação de Automóveis (SIM + N/A)
  const totalGeral = totalSim + totalNa;

  // 1. REGRA PARA AUTOMÓVEL (Baseada no Total Geral de pontos SIM + N/A)
  if (tipo === 'Automóvel') {
    if (totalSim <= 1) {
      this.classificacaoDano = 'Pequena Monta';
    } else if (totalSim <= 6) {
      this.classificacaoDano = 'Média Monta';
    } else {
      this.classificacaoDano = 'Grande Monta';
    }
  }

  
  // 2. REGRA PARA MOTOCICLETA (Conforme impresso no rodapé do laudo PMMG)
  else if (tipo === 'Motocicleta' || tipo === 'Motoneta' || tipo === 'Ciclomotor') {
    if (totalSim === 0) {
      this.classificacaoDano = 'Pequena Monta';
    } else if (totalSim >= 1 && totalSim <= 4) {
      this.classificacaoDano = 'Média Monta';
    } else {
      this.classificacaoDano = 'Grande Monta';
    }
  } 
  
  // 3. REGRA PARA CAMINHÃO, CAVALO MECÂNICO OU ÔNIBUS (Baseada no peso do dano estrutural 'G')
  else if (tipo === 'Caminhão' || tipo === 'Cavalo Mecânico' || tipo === 'Ônibus') {
    const temGrandeMonta = itens.some((i: any) => i.dano === 'SIM' && i.valor === 'G');
    
    if (temGrandeMonta) {
      this.classificacaoDano = 'Grande Monta';
    } else if (totalSim > 0) {
      this.classificacaoDano = 'Média Monta';
    } else {
      this.classificacaoDano = 'Pequena Monta';
    }
  }
  
  // 4. OUTROS VEÍCULOS
  else {
    this.classificacaoDano = totalSim > 0 ? 'Média Monta' : 'Pequena Monta';
  }
}


// Mapeamento das imagens de referência técnica (Anexos I a IV)
get imagensReferencia(): string[] {
  const tipo:string = this.resourceForm.get('tipoVeiculo')?.value;
  const caminhos:any = {
    'Automóvel': [
      'assets/laudo_pmmg/automovel_img1.jpg',
      'assets/laudo_pmmg/automovel_img2.jpg',
      'assets/laudo_pmmg/automovel_img3.jpg',
    ],
    'Motocicleta': [
      'assets/laudo_pmmg/moto_img1.jpg',       
      'assets/laudo_pmmg/moto_img2.jpg'        
    ],
    'Caminhão': [
      'assets/laudo_pmmg/caminhao_img1.jpg',   
      'assets/laudo_pmmg/caminhao_img2.jpg',
      'assets/laudo_pmmg/caminhao_img3.jpg'       
    ],
    'Cavalo Mecânico': [
      
    ],
    'Outros': [   
    ]
  };

  return caminhos[tipo] || [];
}

  salvar() {
    if (this.resourceForm.invalid) {
      this.resourceForm.markAllAsTouched();
      this.info.showErro("Verifique o preenchimento de todos os itens do laudo.");
      return;
    }

   /*   
    const dadosParaSalvar = {
      ...this.resourceForm.value,
      classificacaoFinal: this.classificacaoDano
    };
     console.log("Dados prontos para o serviço:", dadosParaSalvar);
  */

    let postData = {
    'method' : this.resourceForm.get('id')?.value ? 'PUT':'',
    'laudo_uuid' : this.resourceForm.get('id')?.value??'',
    "protocolo_orcamento":this.protocolo,
    "uuid_usuario": this.session.getUUIDUsuario()??'',
    "laudo_tipo_veiculo": this.resourceForm.get('tipoVeiculo')?.value,
    "laudo_bo": this.resourceForm.get('numeroBO')?.value,
    "laudo_agente": this.resourceForm.get('nomeAgente')?.value,
    "laudo_numero_bat": this.resourceForm.get('numeroBat')?.value,
    "laudo_agente_registro": this.resourceForm.get('registroMatricula')?.value,
    "dado_laudo":[
        {
        "item_1": this.resourceForm.get('itens')?.value[0]?.dano??'',
        "item_2": this.resourceForm.get('itens')?.value[1]?.dano??'',
        "item_3": this.resourceForm.get('itens')?.value[2]?.dano??'',
        "item_4": this.resourceForm.get('itens')?.value[3]?.dano??'',
        "item_5": this.resourceForm.get('itens')?.value[4]?.dano??'',
        "item_6": this.resourceForm.get('itens')?.value[5]?.dano??'',
        "item_7": this.resourceForm.get('itens')?.value[6]?.dano??'',
        "item_8": this.resourceForm.get('itens')?.value[7]?.dano??'',
        "item_9": this.resourceForm.get('itens')?.value[8]?.dano??'',
        "item_10": this.resourceForm.get('itens')?.value[9]?.dano??'',
        "item_11": this.resourceForm.get('itens')?.value[10]?.dano??'',
        "item_12": this.resourceForm.get('itens')?.value[11]?.dano??'',
        "item_13": this.resourceForm.get('itens')?.value[12]?.dano??'',
        "item_14": this.resourceForm.get('itens')?.value[13]?.dano??'',
        "item_15": this.resourceForm.get('itens')?.value[14]?.dano??'',
        "item_16": this.resourceForm.get('itens')?.value[15]?.dano??'',
        "item_17": this.resourceForm.get('itens')?.value[16]?.dano??'',
        "item_18": this.resourceForm.get('itens')?.value[17]?.dano??'',
        "item_19": this.resourceForm.get('itens')?.value[18]?.dano??'',
        "item_20": this.resourceForm.get('itens')?.value[19]?.dano??'',
        "item_21": this.resourceForm.get('itens')?.value[20]?.dano??'',
        "item_22": this.resourceForm.get('itens')?.value[21]?.dano??'',
        "laudo_observacao":this.resourceForm.get('observacao')?.value,
        }
      ]
    }  
      this.rest.saveLaudoPMMG(postData).subscribe(
        data => {
          var response = JSON.parse(JSON.stringify(data));
          if (response.status == 'success') {
            let laudo = response.data?.[0];
            if(laudo){
              this.info.showSuccess('Laudo gravado com sucesso');
              this.sendDataForm(laudo);
            }
          }
          //this.bsModalRef.hide();
        });  
  }

  sendDataForm(laudo:any){
    this.resourceForm.reset();
    this.resourceForm.get('id')?.setValue(laudo.uuid);  
    this.resourceForm.get('tipoVeiculo')?.setValue(laudo.laudo_tipo);   
    this.resourceForm.get('numeroBO')?.setValue(laudo.bo);
    this.resourceForm.get('nomeAgente')?.setValue(laudo.agente);
     this.resourceForm.get('numeroBat')?.setValue(laudo.laudo_numero_bat);
    this.resourceForm.get('registroMatricula')?.setValue(laudo.numero_registro);
    this.resourceForm.get('observacao')?.setValue(laudo.observacao);
    this.carregarPerguntas();
    //itens
    this.setValueItem(0,laudo.item_1);
    this.setValueItem(1,laudo.item_2);
    this.setValueItem(2,laudo.item_3);
    this.setValueItem(3,laudo.item_4);
    this.setValueItem(4,laudo.item_5);
    this.setValueItem(5,laudo.item_6);
    this.setValueItem(6,laudo.item_7);
    this.setValueItem(7,laudo.item_8);
    this.setValueItem(8,laudo.item_9);
    this.setValueItem(9,laudo.item_10);
    this.setValueItem(10,laudo.item_11);
    this.setValueItem(11,laudo.item_12);
    this.setValueItem(12,laudo.item_13);
    this.setValueItem(13,laudo.item_14);
    this.setValueItem(14,laudo.item_15);
    this.setValueItem(15,laudo.item_16);
    this.setValueItem(16,laudo.item_17);
    this.setValueItem(17,laudo.item_18);
    this.setValueItem(18,laudo.item_19);
    this.setValueItem(19,laudo.item_20);
    this.setValueItem(20,laudo.item_21);
    this.setValueItem(21,laudo.item_22);
    this.calcularClassificacao();
    
  }

setValueItem(index: number, valor: string) {
  const itens = this.resourceForm.get('itens') as FormArray;
  const itemGroup = itens.at(index) as FormGroup;
  if (itemGroup) {
    itemGroup.get('dano')?.patchValue(valor, { emitEvent: false });   
  }
}

clear(){
  this.resourceForm.reset();
  this.carregarPerguntas();
  this.checkIfEditableTipo();
}

remover(){
   let uuid_laudo =  this.resourceForm.get('id')?.value;
   if(!uuid_laudo){
    this.info.showErro('Nenhum laudo identificado');
    return;
   }
   this.rest.deleteLaudoPMMG(this.protocolo,uuid_laudo).subscribe(
        (data:any) => {
          var response = JSON.parse(JSON.stringify(data));
          if (response.status == 'success') {
              this.info.showSuccess(response.data);
              this.clear();
          }
        }); 
}

 openRelatorio(){
  const initialState = {
      protocolo: this.protocolo,
      };
  const printRef = this.modalService.show(
      LaudopmmgPrintComponent,
      {
          initialState,
          class: 'modal-dialog modal-xl print',
      }
  );
  /*
  printRef.onHidden?.subscribe(() => {
      console.log('Filho fechou');
  });|*/
 } 

 ngOnDestroy() {
    //console.log('Destroy Pai');
}

}